import { Modal, Spinner, } from 'react-bootstrap';
import { useListView } from '../../TenantListView';
import { useGetTenantByIdQuery } from '../../api/api';
import { type CreateEditTenantDto } from '../../api/Types';
import { getUserData } from '../../../../utility/Utils';
import { EditForm } from './EditForm';

function EditModalWrapper() {
  const user = getUserData();

  // If ID === null it means we are in edit mode
  const { toggle, id, } = useListView();

  const { data, isFetching } = useGetTenantByIdQuery(id, {
    skip: !id,
  });

  const tenantForEdit: CreateEditTenantDto = {
    id: undefined,
    editionName: '',
    adminEmailAddress: user.email,
    adminFirstName: user.firstName,
    adminLastName: user.surName,
    editionId: undefined,
    isActive: true,
    name: '',
    powerBiUsername: '',
    powerBiPassword: '',
    projectName: '',
    tenantLogo: '',
    isMappingEnabled: false,
    powerBiWorkspaceUrl: '',
    powerBiServicePrincipalProfileName: '',
    isUsingPowerBiServicePrinciple: false,
    excludedTenantMappingColumnsList: [],
    databaseName: null,
    databaseServer: null,
    isUsingStorageAccount: false,
  };

  let components;

  if (isFetching) {
    components = (
      <div className="d-flex justify-content-center h-100">
        <Spinner animation='border' role='status'>
        </Spinner>
      </div>
    );
  } else if (id && data) {
    components = (
      <EditForm
        tenantForEdit={data}
        editMode
      />
    );
  } else {
    components = (
      <EditForm
        tenantForEdit={tenantForEdit}
        editMode={false}
      />
    );
  }

  return (
    <Modal
      size="xl"
      tabIndex={-1}
      aria-hidden="true"
      show
      scrollable
      dialogClassName="modal-dialog modal-dialog-centered"
      onHide={() => { toggle(null); }}
      contentClassName="bg-transparent"
      backdrop="static"
    >
      <div className="modal-content">
        <Modal.Header closeButton className="border-bottom-0 pb-0">
          {!id ? <h1>Create company</h1> : <h1>Edit company</h1>}
        </Modal.Header>
        <div className="modal-body scroll-y mx-5">
          {components}
        </div>
      </div>
    </Modal>
  );
}

export { EditModalWrapper };
